import React from "react";
import PropTypes from "prop-types";
import styles from "components/dashboard/dashboard.scss";
import { TourMenu } from "components/tours/tour-menu";
import { NoUsageDashboard } from "components/dashboard/no-usage-dashboard";
import { UsageDashboard } from "components/dashboard/usage-dashboard";

export const Dashboard = (props) => (
  <div className={ styles.container }>
    <div className={ styles.dashboard }>
      <Usage { ...props } />
      <TourMenu { ...props } />
    </div>
  </div>
);

Dashboard.propTypes = {
  onStartTour: PropTypes.func.isRequired
};

const Usage = (props) => {
  if (props.totalCount === 0) {
    return <NoUsageDashboard name={ props.name } />;
  }
  return <UsageDashboard { ...props } />;
};

Usage.propTypes = {
  name: PropTypes.string.isRequired,
  totalCount: PropTypes.number.isRequired
};



// WEBPACK FOOTER //
// ./src/js/components/dashboard/dashboard.jsx